// import { get } from "lodash";

export default {
  getEnterpriseLeads: (state) => state.enterpriseLeads.leadsList,
};
